module.exports = __webpack_public_path__ + "static/media/shape_green.9254c912.svg";